import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'atoms/button';
import Dropdown from 'atoms/dropdown';
import Input from 'atoms/input';
import toast from 'atoms/toast';
import { setCustomDiscount } from 'store/reducers/checkout';

export default function CustomDiscount() {
  const dispatch = useDispatch();
  const { customDiscount } = useSelector((state) => state.checkout);
  const [value, setValue] = useState(null);
  const [type, setType] = useState('%');

  const onApply = () => {
    dispatch(setCustomDiscount({ value, type }));
    setValue(null);
  };

  return (
    <div className="mb-12 p-24 border-light-purple radius-24">
      <h4 className="mb-8">Discount</h4>
      <div className="flex-row custom-discount-container">
        <Dropdown
          id="custom-discount"
          className="custom-discount-dropdown"
          items={['%', '$']}
          onClick={(value) => setType(value)}
          value={customDiscount.type}
        />
        <Input
          className="custom-discount-input w-100"
          textAlignment="left"
          placeholder="0.00"
          variant="white"
          size="small"
          onChange={(value) => setValue(value)}
          value={customDiscount.value}
        />
        <Button
          onClick={onApply}
          size="extra-small"
          text="Apply"
          variant={value ? 'green' : 'grey-disabled'}
          shape="square"
        />
      </div>
    </div>
  );
}
